<script lang="ts" setup>
import AsyncText from './AsyncText.vue'

defineProps({
  clientName: null,
  matterName: null,
  principalInjury: null,
  weightmansReference: null,
  insurersHandler: null,
  caseHandler: null,
  accidentDate: null,
  instructionDate: null,
  hasPrediction: { type: Boolean }
})

const emit = defineEmits(["click:pdfReport"])
</script>

<template>
  <header id="predict-header">
    <div class="info">
      <div class="header-title">
        <h2 class="styled step-2 client-name">
          <AsyncText :t="clientName" :length="15" />
        </h2>
        <h1 class="styled step-5 strong matter-name">
          <AsyncText :t="matterName" :length="25" />
        </h1>
      </div>
      <div class="matter-details">
        <div class="left">
          <!-- <dl class="principal-injury inline">
            <dt>Principal Injury:</dt>
            <dd>
              <AsyncText :t="principalInjury" :length="20" />
            </dd>
          </dl> -->
          <dl class="matter-id inline">
            <dt>Matter:</dt>
            <dd>
              <AsyncText :t="weightmansReference" :length="10" />
            </dd>
          </dl>
        </div>
        <div class="matter-handlers">
          <dl class="matter-handler inline">
            <dt>Insurers Handler:</dt>
            <dd>
              <AsyncText :t="insurersHandler" :length="12" />
            </dd>
          </dl>
          <dl class="matter-handler inline">
            <dt>Case Handler:</dt>
            <dd>
              <AsyncText :t="caseHandler" :length="12" />
            </dd>
          </dl>
        </div>
      </div>
    </div>
    <div class="dates">
      <dl class="accident-date">
        <dt>Date of Accident</dt>
        <dd>
          <AsyncText :t="accidentDate" :length="12" />
        </dd>
      </dl>
      <dl class="instruction-date">
        <dt>Date of Instruction</dt>
        <dd>
          <AsyncText :t="instructionDate" :length="12" />
        </dd>
      </dl>
      <WButton v-if="hasPrediction" text="Create PDF Report" @click="emit('click:pdfReport')" />
    </div>
  </header>
</template>

<style lang="scss" scoped>
header#predict-header {
  background-color: var(--app-color-primary);
  color: var(--app-color-on-primary);
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-s);
  padding: var(--space-l);
  min-height: 16rem;
  .info {
    flex: 5;
    display: flex;
    flex-direction: column;
    gap: var(--space-l);
    .header-title {
      display: flex;
      flex-direction: column;
      gap: var(--space-2xs);
    }

    .matter-details {
      display: flex;
      flex-wrap: wrap;
      gap: var(--space-l);

      .left, .matter-handlers {
        display: flex;
        flex-direction: column;
        gap: var(--space-2xs);
      }
    }
  }
  .dates {
    display: flex;
    flex-direction: column;
    gap: var(--space-m);
    flex: 1;
  }
  &:after {
    content: '';
    flex: 0.2;
  }
  h1, h2 {
    color: inherit;
  }
}

@media print {
  header#predict-header {
    min-height: 13rem !important;
    padding-inline-start: 3rem !important;
    padding-inline-end: 3rem !important;
  }

}
</style>
